export default __webpack_public_path__ + "static/media/close-black.9f2c5c67.svg";